import styled from "styled-components";

import logoMobileSrc from "../../images/logo-mobile.png";
import logoDesktopSrc from "../../images/logo-desktop.png";
import bbqBgSrc from "../../images/not-available-bbq.png";

export const Root = styled.div`
  display: flex;
  justify-content: center;
  left: 0;
  width: 100%;
  position: ${p => (p.$isSticky ? "fixed" : "absolute")};
  background-color: ${p => (p.$isSticky ? "#171717" : "transparent")};
  z-index: 1000;

  @media (max-width: 1023px) {
    height: ${p => p.$isSticky && "65px"};
    padding: 0 25px;
  }

  @media (min-width: 1024px) {
    height: ${p => (p.$isSticky ? "90px" : "auto")};
    top: ${p => (p.$isSticky ? 0 : "46px")};
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (min-width: 1024px) {
    max-width: 1920px;
    padding: 0 32px;
  }

  @media (min-width: 1150px) {
    padding: 0 80px;
  }
`;

export const LogoContainer = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: contain;
  text-indent: -9999px;
  white-space: nowrap;

  @media (max-width: 1023px) {
    width: ${p => (p.$isSticky ? "162px" : "190px")};
    height: ${p => (p.$isSticky ? "45px" : "60px")};
    margin-top: ${p => (p.$isSticky ? 0 : "60px")};
    background-image: url(${logoMobileSrc});
  }

  @media (min-width: 1024px) {
    width: ${p => (p.$isSticky ? "232px" : "356px")};
    height: ${p => (p.$isSticky ? "70px" : "115px")};
    background-image: url(${logoDesktopSrc});
    background-color: ${p => (p.$isSticky ? "#171717" : "transparent")};
    transform: ${p => (p.$isSticky ? "translateY(0)" : "translateY(27px)")};
  }
`;

export const MenuBtn = styled.button`
  position: absolute;
  top: ${p => (p.$isSticky ? "10px" : "68px")};
  right: 25px;
  width: 45px;
  height: 45px;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 45px;
  pointer-events: all;
  z-index: 1;

  &.--menu {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath fill='%23fff' d='M45 12.25H0v-1.5h45v1.5Zm0 11.239H0v-1.5h45v1.5Zm0 10.761H0v-1.5h45v1.5Z'/%3E%3C/svg%3E");
  }

  &.--close {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath fill='%23fff' d='M37.88 38.94 22.5 23.56 7.12 38.94l-1.06-1.06L21.44 22.5 6.06 7.12l1.06-1.06L22.5 21.44 37.88 6.06l1.06 1.06L23.56 22.5l15.38 15.38-1.06 1.06Z'/%3E%3C/svg%3E");
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const MobileMenuContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #171717;
  background-image: url(${bbqBgSrc});
  background-repeat: no-repeat;
  background-position-x: calc(100% + 15px);
  background-position-y: 174px;
  background-size: auto 328px;
  overflow-y: auto;
  pointer-events: all;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 40px);
  min-height: 600px;

  @media (max-height: 719px) {
    padding: 130px 25px 30px;
  }

  @media (min-height: 720px) {
    padding: 190px 25px 30px;
  }
`;

export const MobileNavList = styled.ul`
  @media (min-height: 815px) {
    margin-bottom: 72px;
  }
`;

export const DesktopNavList = styled.ul`
  display: flex;
  align-items: center;
  height: fit-content;
  pointer-events: all;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  display: block;
  color: rgba(255, 255, 255, 0.8);
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;
  text-decoration: none;
  line-height: 1;

  &:hover,
  &.--active {
    color: #fff;
  }

  @media (max-width: 1023px) {
    font-size: 38px;
    line-height: 1.47;
    text-align: center;

    &.--accent {
      color: #c49f3f;
    }
  }

  @media (min-width: 1024px) {
    padding: 6px 20px;
    font-size: 18px;
  }
`;

export const SocialContainer = styled.div`
  margin-top: auto;
  text-align: center;
`;
